import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _size from "lodash/size";
import _map from "lodash/map";
import _uniq from "lodash/uniq";
import _filter from "lodash/filter";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.slice.js";
import FastqFileType from 'const/enums/FastqFileType';
import { isMaxWtKit } from 'const/enums/KitCategory';
import { isParseSampleTech } from 'const/enums/SampleTech';
var MAX_WT_FAMILY_KIT = 'max_wt';
var barcodingModuleOptions = [{
  label: 'Cell Barcoding S',
  value: 's'
}, {
  label: 'Cell Barcoding M',
  value: 'm'
}, {
  label: 'Cell Barcoding L',
  value: 'l'
}, {
  label: 'Cell Barcoding L-384',
  value: 'l_384'
}];

// A lot of pieces of code rely on checking startsWith against the values
// (for example, the KitCategory.fromKit function).
// So be careful if changing them.
// Migrate to explicit "includes" checks if this begins causing issues.
var kitOptions = [{
  label: 'Evercode WT Mini',
  value: 'wt_mini'
}, {
  label: 'Evercode WT',
  value: 'wt'
}, {
  label: 'Evercode WT Mega',
  value: 'wt_mega'
}, {
  label: 'Evercode WT Mega 384',
  value: 'wt_mega_384'
}, {
  label: 'Evercode WT Penta',
  value: 'wt_penta'
}, {
  label: 'Evercode WT Penta 384',
  value: 'wt_penta_384'
},
// TODO:Hidden from selection until Evercode MAX WT is ready for release.
// Uncomment once we're ready to release. Remember to update tests
{
  label: 'Evercode MAX WT',
  value: MAX_WT_FAMILY_KIT
},
// <--- unhidden temporarily to test insights
{
  label: 'Evercode TCR Mini',
  value: 'tcr_mini'
}, {
  label: 'Evercode TCR',
  value: 'tcr'
}, {
  label: 'Evercode TCR Mega',
  value: 'tcr_mega'
}, {
  label: 'Evercode BCR Mini',
  value: 'bcr_mini'
}, {
  label: 'Evercode BCR',
  value: 'bcr'
}, {
  label: 'Evercode BCR Mega',
  value: 'bcr_mega'
}];
var labelsByFastqType = _defineProperty(_defineProperty({}, FastqFileType.WT_FASTQ, 'WT'), FastqFileType.IMMUNE_FASTQ, 'Immune');
var getKitLabel = function getKitLabel(kit) {
  var _kitOptions$find2;
  if (isMaxWtKit(kit)) {
    var _kitOptions$find, _barcodingModuleOptio;
    var familyLabel = (_kitOptions$find = kitOptions.find(function (option) {
      return option.value === MAX_WT_FAMILY_KIT;
    })) === null || _kitOptions$find === void 0 ? void 0 : _kitOptions$find.label;
    var size = kit.slice(MAX_WT_FAMILY_KIT.length + 1);
    var sizeLabel = (_barcodingModuleOptio = barcodingModuleOptions.find(function (option) {
      return option.value === size;
    })) === null || _barcodingModuleOptio === void 0 ? void 0 : _barcodingModuleOptio.label;
    return sizeLabel ? "".concat(familyLabel, " (").concat(sizeLabel, ")") : familyLabel;
  }
  return (_kitOptions$find2 = kitOptions.find(function (option) {
    return option.value === kit;
  })) === null || _kitOptions$find2 === void 0 ? void 0 : _kitOptions$find2.label;
};

// The kit all the given Parse samples come from, or undefined if they come from
// different kits or any has none (samples created before kits were stored per sample)
var getSharedKit = function getSharedKit(samples) {
  var _kits$;
  var parseSamples = _filter(samples, function (sample) {
    return isParseSampleTech(sample === null || sample === void 0 ? void 0 : sample.type);
  });
  var kits = _uniq(_map(parseSamples, 'kit'));
  return _size(kits) === 1 ? (_kits$ = kits[0]) !== null && _kits$ !== void 0 ? _kits$ : undefined : undefined;
};
export default kitOptions;
export { labelsByFastqType, MAX_WT_FAMILY_KIT, getKitLabel, getSharedKit, barcodingModuleOptions };